<template>
  <div>
    <h1 class="first-header heading-medium">
      <i class="fas fa-chart-line mr-2"></i>
      Market Prices
    </h1>
    <div
      class="table-container"
      :class="{
        'justify-content-center': productPrices.length < 1,
        card: homePage,
        'px-3': $breakpoint.mdAndDown && homePage,
      }"
    >
      <div v-if="homePage" class="row mx-0" :class="$breakpoint.lgAndDown ? 'pt-3 pb-3' : 'py-3'">
        <div class="col-md-12 col-sm-6 offset-sm-6 col-12 offset-md-0" :class="{ 'px-0': $breakpoint.mdAndDown }">
          <button @click="$store.dispatch('livePrices/editSettlementPrices')" class="btn btn-actionable float-right">
            {{ settlementPricesButtonText }}
          </button>
        </div>
      </div>
      <div v-if="productPrices.length < 1" class="alert tables-alert-custom-message-notify mt-3 text-center">
        <i class="fas fa-info-circle mr-2"></i>Market Prices will not be displayed until Settlement prices have been
        updated. Click on {{ settlementPricesButtonText }} to update Settlement Prices
      </div>
      <div v-else>
        <marketPrices :productData="orderedProductIds" :productPrices="getPrices" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import breakpoint from "@/mixins/index";
import marketPrices from "@/components/marketPrices/marketPrices.vue";

export default {
  components: {
    marketPrices,
  },
  mixins: [breakpoint],
  data: function () {
    return {
      homePage: false,
    };
  },
  computed: {
    ...mapState("livePrices", ["showDailyPriceModal"]),
    ...mapGetters("livePrices", ["getPrices", "getPricesUpdate", "settlementPricesButtonText"]),
    orderedProductIds() {
      const acceptedProductList = [
        "DieselId",
        "BioDieselId",
        "BlendedDieselBioId",
        "GasoilId",
        "BlendedGasoilId",
        "KeroseneId",
        "PetrolId",
        "PetrolWithAdditiveId",
        "SU97Id",
        "SU99Id",
        "GasoilFame0Id",
        "DieselWithAdditiveId",
        "HVOId",
        "MarineGasoilId",
        "HighBioMarineDieselId",
        "PremiumDieselId",
      ];
      const productConfig = this.$store.getters["metadata/productConfig"];
      return acceptedProductList.map((item) => productConfig[item]);
    },
    productPrices() {
      let prices = [];

      if (this.getPrices && this.getPrices.length > 0) {
        for (const productId of this.orderedProductIds) {
          const product = this.getPrices.find((p) => p.fuel_id === productId); // Find the matching product
          prices.push(product);
        }
      }
      return prices;
    },
  },
  methods: {},
  created() {
    if (this.$route.name === "manageOffers") {
      this.homePage = false;
    } else {
      this.homePage = true;
    }
  },
};
</script>

<style lang="scss" scoped>
th,
td:not(.no-results) {
  @include media-breakpoint-up(lg) {
    width: calc(100% / 7);
  }
}

th:not(:first-of-type),
td {
  text-align: center;
}

#select-currency {
  max-width: 200px;
  display: inline-block;
  height: 1.5rem;
  margin: 0.5rem;
}
</style>